import Card from '../components/common/Card';
import PageHero from '../components/layout/PageHero';

function AboutCEO() {
  return (
    <>
      <PageHero
        eyebrow="Leadership"
        title="About CEO"
        description="Founder leadership, operating vision, and company direction will be expanded here."
      />
      <section className="section page-content">
        <div className="container">
          <Card>
            <h2>Content will be added soon</h2>
            <p>
              This page is reserved for Founder & CEO Satyam Kumar's professional profile and
              FactorStreet leadership story.
            </p>
          </Card>
        </div>
      </section>
    </>
  );
}

export default AboutCEO;
